/**
 * Renders the preloader
 */

const Loader = ({ isLoading }: { isLoading: boolean }) => {
  return (
    <div className={`w-full h-full fixed top-0 left-0 right-0 bottom-0 opacity-40 z-50 content-center transition-opacity duration-500 ease-in-out ${isLoading ? 'opacity-40 z-50' : 'opacity-0 z-0'}`}>
      <div className="flex items-center justify-center text-primary-main">
        <svg className="animate-spin h-12 w-12" fill="none" viewBox="0 0 24 24">
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      </div>
    </div>
  );
};

export default Loader;
